export default "__VITE_ASSET__DXOE$8OM__"